'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.toggleClassWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this,
			toggleClass = widget.attr('data-mm-toggle-class').trim(),
			targetSelector = widget.attr('data-mm-target-selector') || 'body';
		if (toggleClass) {
			widget.on('click', function () {
				mmWidgets(targetSelector).toggleClass(toggleClass);
			});
		}
	});
};
